var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/ban-types */
import * as React from 'react';
import { Typography } from '@mui/material';
import MidmarkOverflowTooltip from '../OverflowTooltip/MidmarkOverflowTooltip';
const MidmarkTypography = (_a) => {
    var { variant = 'body1', title, tooltipProps } = _a, props = __rest(_a, ["variant", "title", "tooltipProps"]);
    const typographyRef = React.createRef();
    const typography = (_jsx(Typography, Object.assign({ ref: typographyRef, variant: variant }, props)));
    if (title == null) {
        return typography;
    }
    return (_jsx(MidmarkOverflowTooltip, Object.assign({}, tooltipProps, { title: title, elementRef: typographyRef }, { children: typography })));
};
export default MidmarkTypography;
